import React, { useState, useEffect, useRef } from "react";
import {

  Box,
  Button,
  Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Email as EmailIcon, Lock as LockIcon } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../components/language/languageContext";
import Loader from "../../components/Loader/Loader";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

import axios from "axios";
import Cookies from "js-cookie";
import ForgotPassword from "../Forgotpassword/forgotPassword";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
// import Freetrial from "../../PreloginComponent/Layout/Freetrial";
import "../../../src/userAuth/Login/index.scss";
import TermsandConditions from "./termsandconditions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

//backgound image
const login_bg_image = VISUALIZE__URL + "login_bg_image.webp";

type LoginProps = {
  firstName: string;
  lastName: string;
  emailId: string;
  phone: string;
  otpSent: boolean;
  otpVerified: boolean;
  verificationCode: string;
  accessToken: string;
  viewType: number;
  languageId: number;
  isSessionToken: boolean;
};

const Login = () => {
  const token: any = Cookies.get("userToken");

  const location = useLocation();
  if (token) {
    const lastPath = location.state?.from?.pathname || "/home";
    // Redirect to the home page if token exists
    return <Navigate to={lastPath} replace />;
  }
  const {
  } = useLanguageContext();

  const { t } = useTranslation();

  const [isScrolling, setIsScrolling] = useState(false); // State to track scrolling
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [getMail, mailSet] = useState("");
  const [getMobile, mobileSet] = useState("");
  const [getUserDetail, _userDetail] = useState<string[]>(new Array(0));
  const [isDiasbleBtn, setSubBtnDisabled] = React.useState(false);
  const [adminLoader, setAdminLoading] = useState(true);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  // Otp State
  const [otpError, setOTPError] = useState("");
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const otpFieldsRef = useRef<HTMLInputElement[]>([]);
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(true);
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(""));
  const [isAccessToken, setAccessToken] = useState(String);
  const [isChecked, setIsChecked] = useState(false); // State to manage checkbox status
  const [openModal, setOpenModal] = useState(false);
  // const [openTrialModal, setOpenTrialModal] = useState(false);
  const [openterms, setOpenterms] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState<"terms" | "privacy">("terms");
  //for multiple user login popup status
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [_pendingLoginData, setPendingLoginData] = useState<LoginProps | null>(
    null
  );
  const [isSessionValidation, setIsSessionValidation] = useState(false);


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // Adjust the scroll threshold
        setIsScrolling(true); // Set to true when scrolled down
      } else {
        setIsScrolling(false); // Set to false when at the top
      }
    };
    // Listen for scroll events
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Timer Function
  useEffect(() => {
    const interval = setInterval(() => {
      // Decrease seconds if greater than 0
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        setIsDisabled(true);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [seconds]); // Re-run this  effect whenever 'Seconds' Changes

  // Otp Focus Function
  useEffect(() => {
    if (otpFieldsRef.current[0]) {
      otpFieldsRef.current[0].focus();
    }
    let isMounted = true;
    if (isMounted) {
    }
    return () => {
      isMounted = false;
    };
  }, []);

  // Username Validation
  const validateUsername = (): boolean => {
    if (!username) {
      setUsernameError("Username is required");
      return false;
    }
    setUsernameError("");
    return true;
  };

  // Password  validation
  const validatePassword = (): boolean => {
    if (!password) {
      setPasswordError("Password is required");
      return false;
    }
    setPasswordError("");
    return true;
  };

  // Modal Close Function
  const handleClose = () => {
    setOpen(false);
    setSubBtnDisabled(false);
  };
  const handleopenterms = (type: "terms" | "privacy") => {
    setModalType(type);
    setModalTitle(
      type === "terms" ? t("terms_conditions") : t("privacy_policy")
    );
    setOpenterms(true);
  };

  const handlecloseterms = () => {
    setOpenterms(false);
  };


  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {

    window.gtag("event", "login_form", {
      page_path: window.location.pathname,
      form_type: "login_submission",
      username: username,
      environment: process.env.NODE_ENV,
    })
    console.log("Login submit button clicked event sent!");
    
    e.preventDefault();
    const isUsernameValid = validateUsername(); // Validate username
    const isPasswordValid = validatePassword(); // Validate password
    if (!isUsernameValid || !isPasswordValid) return; // If validation fails, return
    setSubBtnDisabled(true); // Set submit button disabled
    // Example payload (replace with your actual data structure)
    const payload = {
      username: username, // Assuming these return the actual values, not boolean
      password: password,
      isSession: isSessionValidation,
      // domain: domain
    };
    axios
      .post(API_BASE_URL + "auth/login/", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const allData = response.data;
        if (allData.statusCode >= 200 && allData.statusCode <= 300) {
          // clear share animation data from localstorage
          localStorage.removeItem("cartCount");
          localStorage.removeItem("selectAnim");
          localStorage.removeItem("myVideosAnim");

          const data: LoginProps = allData.data;
          // Set access token in state
          if (data.isSessionToken) {
            setPendingLoginData(data); // Store login data temporarily
            setConfirmDialogOpen(true); // Show confirmation popup
            return; // Stop further execution
          }

          proceedWithLogin(data);

        } else {
          // Invalid username or password credentials
          toast.error(t("invalid_username_or_password!"), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setSubBtnDisabled(false);
        }
      })
      .catch((error) => {
        console.error("Error during login:", error);
        const errorMessage = error.response.data.message;
        toast.error(errorMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setSubBtnDisabled(false);
      });
  };

  // Handle confirmation popup actions
  const handleConfirmYes = () => {

    setIsSessionValidation(true);
    const isUsernameValid = validateUsername(); // Validate username
    const isPasswordValid = validatePassword(); // Validate password
    if (!isUsernameValid || !isPasswordValid) return; // If validation fails, return
    setSubBtnDisabled(true); // Set submit button disabled
    // Example payload (replace with your actual data structure)
    const payload = {
      username: username, // Assuming these return the actual values, not boolean
      password: password,
      isSession: true,
      // domain: domain
    };
    axios
      .post(API_BASE_URL + "auth/login/", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const allData = response.data;
        if (allData.statusCode >= 200 && allData.statusCode <= 300) {
          localStorage.removeItem("cartCount");
          localStorage.removeItem("selectAnim");
          const data: LoginProps = allData.data;
          proceedWithLogin(data);
        } else {
          // Invalid username or password credentials
          toast.error(t("invalid_username_or_password!"), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          setSubBtnDisabled(false);
        }
      })
      .catch((error) => {
        console.error("Error during login:", error);
      });
    setConfirmDialogOpen(false);
  };

  const handleConfirmNo = () => {
    setConfirmDialogOpen(false);
    setSubBtnDisabled(false);
  };
  const proceedWithLogin = (data: LoginProps) => {

    localStorage.setItem("firstName", data.firstName);
    localStorage.setItem("lastName", data.lastName);
    localStorage.setItem("viewType", data.viewType.toString());
    setAccessToken(data.accessToken);

    if (data.emailId) {
      const [be_mail, domain] = data.emailId.split("@");
      const finalMail =
        be_mail.substring(0, 2) + "***" + be_mail.slice(-1) + "@" + domain;
      mailSet(finalMail);
      getUserDetail.push(finalMail);
    }

    if (data.phone) {
      const finalMob =
        data.phone.substring(0, 2) + "******" + data.phone.slice(-2);
      mobileSet(finalMob);
      getUserDetail.push(finalMob);
    }

    setSubBtnDisabled(true);


    if (!data.otpVerified) {

      setOpen(true);
      handleAutofillOTP(data.verificationCode);
    } else {

      setOpen(false);
      toast.success(t("login_successful"), {
        autoClose: 1000,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        onClose: () => navigate("/home", { replace: true }),
      });

      Cookies.set("userToken", data.accessToken, {
        expires: 1,
        // expires: new Date(new Date().getTime() + 1 * 60 * 1000), // 5 minutes
        path: "/",
        secure: true,
        sameSite: "Strict",
      });

      const authChannel = new BroadcastChannel("auth");
      authChannel.postMessage({ type: "login", token: data.accessToken });
    }
  };

  // Username Change function
  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value);
    if (e.target.value) {
      setUsernameError("");
    }
  };

  // Password Change function
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (e.target.value) {
      setPasswordError("");
    }
  };

  //Password Show Hide
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // OTP Validation
  const validateOTP = (): boolean => {

    if (!otp[0] || !otp[1] || !otp[2] || !otp[3] || !otp[4] || !otp[5]) {
      setOTPError("OTP is required");
      return false;
    }
    setOTPError("");
    return true;
  };
  // Function to resend OTP
  const resendOtp = () => {

    window.gtag("event", "otp_resend", {
      page_path: window.location.pathname,
      form_type: "otp_validation",
      username: username,
      environment: process.env.NODE_ENV,
    })
    console.log("otp resend event sent!");

    setOtp(Array(6).fill(""));
    setIsDisabled(false);
    setMinutes(0);
    setSeconds(40);

    const payload = {
      emailId: getMail,
      phone: getMobile,
    };
    const resendCode = async () => {
      try {
        const response = await axios.post(
          API_BASE_URL + "auth-v2/resend-otp",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${isAccessToken}`,
            },
          }
        );
        if (response.status >= 200 && response.status <= 300) {
          const str: string = String(response.data.data.verificationCode);
          handleAutofillOTP(str);
        }
      } catch (error: any) {
        console.log(error);
      }
    };
    resendCode();
    setIsBtnDisabled(true);
  };

  // Otp Section
  // Checkbox change function
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked); // Update the state based on checkbox status
  };

  // Otp change function
  const handleOTPChange = (value: any, index: number) => {
    const newOtp = [...otp];
    if (!isNaN(value)) {
      newOtp[index] = value;
      // Move to the next field if the value is not empty
      if (value && otpFieldsRef.current[index + 1]) {
        otpFieldsRef.current[index + 1].focus();
      }
      setOtp(newOtp);
    } else {
    }
  };

  // Otp Enter Keyup Function
  const handleKeyUp = (event: React.KeyboardEvent, index: number) => {
    const { key } = event;
    // if (key === 'Backspace' || key === 'Delete') {    // old code
    if (key === "Backspace") {
      if (index > 0) {
        otpFieldsRef.current[index - 1]?.focus();
      }
    } else if (key === "ArrowLeft" || key === "ArrowDown") {
      if (index > 0) {
        otpFieldsRef.current[index - 1]?.focus();
      }
    } else if (key === "ArrowRight" || key === "ArrowUp") {
      if (index < otpFieldsRef.current.length - 1) {
        otpFieldsRef.current[index + 1]?.focus();
      }
    }
    if (
      otp[0] != "" &&
      otp[1] != "" &&
      otp[2] != "" &&
      otp[3] != "" &&
      otp[4] != "" &&
      otp[5] != ""
    ) {
      setIsBtnDisabled(false);
    } else {
      setIsBtnDisabled(true);
    }
  };

  // OTP paste function
  const handlePaste = (event: React.ClipboardEvent, _index: number) => {
    event.preventDefault();

    // Get pasted data and sanitize it
    const pasteData = event.clipboardData.getData("text").slice(0, 6); // Max 6 digits
    const newOtp = pasteData
      .split("")
      .map((char) => char.replace(/[^0-9]/g, ""));

    // Ensure the OTP array has 6 elements
    for (let i = newOtp.length; i < 6; i++) {
      newOtp.push("");
    }

    // Update the OTP state
    setOtp(newOtp);

    // Update the values in the input fields and focus
    let lastFilledIndex = 0; // Track the last non-empty input
    newOtp.forEach((value, i) => {
      if (otpFieldsRef.current[i]) {
        otpFieldsRef.current[i].value = value;
        if (value !== "") {
          lastFilledIndex = i; // Update to the last non-empty input
        }
      }
    });
    // Move focus to the last filled input (or the next one if possible)
    if (otpFieldsRef.current[lastFilledIndex + 1]) {
      otpFieldsRef.current[lastFilledIndex + 1].focus();
    } else if (otpFieldsRef.current[lastFilledIndex]) {
      otpFieldsRef.current[lastFilledIndex].focus();
    }
  };


  //OTP Submit
  const handleOTPSubmit = (e: React.FormEvent<HTMLFormElement>) => {

    window.gtag("event", "otp_verify", {
      page_path: window.location.pathname,
      form_type: "otp_validation",
      username: username,
      environment: process.env.NODE_ENV,
    })
    console.log("otp verify event sent!");

    e.preventDefault();
    setIsBtnDisabled(true);
    const isOTPValid = validateOTP();
    if (!isOTPValid) return;
    const otpNum = otp.map(String).join(""); // Convert to string and join
    const payload = {
      otpCode: otpNum,
      isOTPVerified: isChecked,
    };
    const verifyCode = async () => {
      try {
        const response = await axios.post(
          API_BASE_URL + "auth-v2/verify-code",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${isAccessToken}`,
            },
          }
        );
        if (response.status >= 200 && response.status <= 300) {
          setIsDisabled(true);

          Cookies.set("userToken", isAccessToken, {
            expires: 1, // Cookie will expire in 7 days
            path: "/", // Cookie is accessible throughout the site
            secure: true, // Cookie is sent only over HTTPS
            sameSite: "Strict", // Protects against CSRF
          });
          setOpen(false);
          toast.success(t("login_successful"), {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            onClose: () => navigate("/home"),
          });
        }
      } catch (error: any) {
        // setOpen(false);
        setIsBtnDisabled(false);

        toast.error(error.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.error("API Error:", error.response?.data || error.message);
      }
    };

    verifyCode();
  };

  //OTP autofill
  const handleAutofillOTP = (apiResponseCode: string) => {
    const otpArray = apiResponseCode.split("").slice(0, 6); // Ensure it matches field count
    setOtp(otpArray);

    // Autofocus the last field
    if (otpArray.length > 0) {
      otpFieldsRef.current[otpArray.length - 1]?.focus();
    }
    setIsBtnDisabled(false);
  };
  // const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Stores the 6 OTP digits

  useEffect(() => {
    const timer = setTimeout(() => {
      setAdminLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (adminLoader) {
    return <Loader />;
  }


  // Modal open and close
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };


  return (
    <>
      <Grid
        container
        sx={{
          height: "100vh",
          width: "100vw",
          background: "#ffffff",
        }}
      >
        {/* Left Section */}
        <Grid
          className="left_sec"
          item
          xs={12}
          sm={7} // Half width on medium and larger screens
          sx={{
            position: "relative",
            backgroundImage: `url(${login_bg_image})`,
            backgroundSize: "cover",
            backgroundPosition: " center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: "white",
            clipPath: {
              xs: "none", // No clipPath for smaller screens
              sm: "none", // No clipPath for small screens
              md: "polygon(0 0, 99% 0, 85% 100%, 0% 100%)", // Apply clipPath for medium and larger screens
            },
            px: 4,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust the overlay color and opacity
              zIndex: 1, // Ensure the overlay is above the background but below content
            },
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              position: "relative",
              zIndex: 2, // Ensure content is above overlay
              pl: { xs: 1, sm: 1, md: 2, lg: 2 },
              pt: { xs: 1, sm: 1, lg: 2, md: 2 },
            }}
          >
            <Grid item xs={12}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  fontSize: { xs: "20px", sm: "25px", md: "28px", lg: "35px" },
                }}
              >
                {t("login_innovative_animations")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  maxWidth: "500px",
                  textAlign: "left",
                  mb: 4,
                  fontSize: "17px",
                  lineHeight: "24px",
                }}
              >
                {t("login_explore_our_cuting")}
              </Typography>
            </Grid>
            <Button
              variant="contained"
              onClick={() => navigate("/freetrial")}
              sx={{
                mt: 2,
                ml: 3,
                px: 4,
                py: 1.5,
                borderRadius: "30px",
                fontSize: { xs: "12px", md: "16px" },

                fontWeight: "bold",

                backgroundColor: "#24BD40",
                "&:hover": {
                  backgroundColor: "#24BD40",
                },
                animation: "bounce 2s infinite",
                textTransform: "none",
              }}
            >
              {t("free_trial")}
            </Button>

            {/* Free Trial Modal */}
            {/* <Freetrial
              openTrialModal={openTrialModal}
              setOpenTrialModal={setOpenTrialModal}
            /> */}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={5}
          sx={{
            backgroundColor: "#ffffff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: { xs: 2, sm: 4 },
            position: "relative",
          }}
        >
          {/* Form Content */}
          <Box
            className="login_form"
            sx={{
              width: "80%",
              maxWidth: { sm: "100%" },
              marginBottom: 10,
              padding: 4,
              textAlign: "left", // Ensure left alignment
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Box
              component="img"
              src={`${VISUALIZE__URL}Clinical_Visuals_Logo.webp`}
              alt="Logo"
              sx={{
                height: "auto",
                marginBottom: 5,
                width: { xs: 200, sm: 200, md: 200, lg: 250 },
                opacity: isScrolling ? 0 : 1,
                alignSelf: "center",
                justifyContent: "center",
                marginLeft: 0,
                "@media(min-Width:1440px)": {
                  marginLeft: -20,
                },
                "@media (min-width: 1080px) and (max-width: 1920px)": {
                  marginLeft: -5,
                },
              }}
              onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />

            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                mb: 1,
                color: "#1976D2",
              }}
            >
              {t("welcome_back")}
            </Typography>
            {/* Form */}
            <form
              className="form"
              id="login_form"
              noValidate
              onSubmit={handleSubmit}
            >
              <TextField
                placeholder={t("username")}
                fullWidth
                type="email"
                variant="outlined"
                required
                margin="normal"
                name="username"
                autoComplete="off"
                InputProps={{
                  sx: {
                    borderRadius: 20,
                    lineHeight: 0.7,
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
                value={username}
                onChange={handleUsernameChange}
                error={!!usernameError}
                helperText={usernameError}
              />
              <TextField
                required
                fullWidth
                name="password"
                placeholder={t("password")}
                type={showPassword ? "text" : "password"}
                variant="outlined"
                margin="normal"
                autoComplete="current-password"
                InputProps={{
                  sx: {
                    borderRadius: 20,
                    lineHeight: 0.7,
                    color: "#000",
                    "&::placeholder": {
                      opacity: 1,
                    },
                  },
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={togglePasswordVisibility}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                value={password}
                onChange={handlePasswordChange}
                error={!!passwordError}
                helperText={passwordError}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                  },
                }}
              />
              {/* Forgot Password and Remember Me */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: 2,
                  color: "gray",
                }}
              >
                <Link
                  underline="none"
                  sx={{
                    color: "primary.main",
                    fontSize: "16px",
                    letterSpacing: 0.3,
                    cursor: "pointer",
                  }}
                  onClick={handleOpenModal}
                >
                  {t("forgot_password")}?
                </Link>
                <ForgotPassword
                  open={openModal}
                  handleClose={handleCloseModal}
                />
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Button
                  className="btn"
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                  disabled={isDiasbleBtn}
                  sx={{
                    mt: 2,
                    height: "45px",
                    width: "40%",
                    justifyContent: "center",
                    fontSize: "16px",
                    borderRadius: "10px",
                    textTransform: "none",
                  }}
                >
                  {t("sign_in")}
                </Button>
              </Box>
            </form>
          </Box>
        </Grid>
        <Grid
          container
          sx={{
            pl: 4,
            pb: 1,
            background: "transparent",
            position: "fixed",
            bottom: 0,
          }}
        >
          <Grid item xs={12}>
            <Box
              className="login_footer"
              sx={{
                display: "flex",
                justifyContent: "left", // Center the links horizontally
                alignContent: "left",
                gap: 2, // Space between links
              }}
            >

              <Link
                href="#"
                underline="none"
                sx={{
                  fontWeight: 500,
                  padding: "5px",
                  color: { xs: "darkgray", sm: "white" },
                  fontSize: { xs: "12px", sm: "15px" },
                  cursor: "pointer",
                  "&:hover": {
                    cursor: "pointer",
                    textDecoration: "underline",
                  },
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleopenterms("terms");
                }}
              >
                {t("terms_conditions")}
              </Link>

              <Link
                href="#"
                underline="none"
                sx={{
                  fontWeight: 500,
                  padding: "5px",
                  color: { xs: "darkgray", sm: "white" },
                  fontSize: { xs: "12px", sm: "15px" },
                  cursor: "pointer",
                  "&:hover": {
                    cursor: "pointer",
                    textDecoration: "underline",
                  },
                }}
                onClick={(e) => {
                  e.preventDefault();
                  handleopenterms("privacy");
                }}
              >
                {t("privacy_policy")}
              </Link>

              {/* Use Modal Component */}
              <TermsandConditions
                open={openterms}
                handleCloseTerms={handlecloseterms}
                title={modalTitle}
                type={modalType} // 🔹 Pass 'type' prop (required in API fetch)
              />

              <Link
                href="/contactus"
                underline="none"
                sx={{
                  fontWeight: 500,
                  backgroundColor: "#1976d2",
                  borderRadius: "5px",
                  border: "1px solid  #55aaff",
                  padding: "5px",
                  color: { xs: "darkgray", sm: "white" },
                  fontSize: { xs: "12px", sm: "15px" },
                }}
              >
                {t("contact_us")}
              </Link>
            </Box>
          </Grid>
        </Grid>
        {/* OTP popup  */}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="Verification Request"
          aria-describedby="OTP Verification"
          sx={{
            backdropFilter: "blur(3px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "80%", sm: "450px" }, // Set width based on screen size
              maxWidth: "500px", // Optional: Set a max width for larger screens
              bgcolor: "background.paper",
              borderRadius: "25px",
              boxShadow: 24,
              p: { xs: 2, sm: 3 }, // Adjust padding for smaller screens
              textAlign: "center",
            }}
          >
            <Typography
              id="popup-title"
              variant="h6"
              component="h2"
              sx={{
                mb: 2,
                fontSize: { xs: "20px", sm: "24px" },
                fontWeight: 600,
              }}
            >
              {t("verify_request")}
            </Typography>
            {getMail && !getMobile && (
              <Grid p={2}>
                <Typography component="span">
                  {t("email_otp_content")} {getMail}
                </Typography>
              </Grid>
            )}
            {getMobile && !getMail && (
              <Grid p={2}>
                <Typography component="span">
                  {t("email_sms_otp_content")} {getMobile}
                </Typography>
              </Grid>
            )}
            {getMail && getMobile && (
              <Grid p={2}>
                <Typography component="span">
                  {t("email_otp_content")} {getMail} {t("and_sms_content")}{" "}
                  {getMobile}
                </Typography>
              </Grid>
            )}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 1,
                justifyContent: "center",
              }}
            >
              <form
                className="form otp-form"
                noValidate
                onSubmit={handleOTPSubmit}
              >
                {otp.map((value, index) => (
                  <TextField
                    key={index}
                    type="text"
                    id={`otp-input-${index}`}
                    inputProps={{
                      maxLength: 1,
                      pattern: "[0-9]",
                      onKeyDown: (event) => {
                        if (
                          event.key === "e" ||
                          event.key === "E" ||
                          event.key === "+" ||
                          event.key === "-" ||
                          event.key === "." ||
                          event.key === " "
                        ) {
                          event.preventDefault();
                        }
                      },
                      style: { textAlign: "center", fontSize: "24px" },
                    }}
                    value={value}
                    onChange={(e) => handleOTPChange(e.target.value, index)}
                    onKeyUp={(e) => handleKeyUp(e, index)}
                    onPaste={(e) => handlePaste(e, index)}
                    sx={{
                      width: "45px",
                      height: "45px",
                      marginRight: "5px",
                      borderRadius: "15px",
                      "& .MuiInputBase-root": {
                        padding: 0,
                        textAlign: "center",
                      },
                      "& .MuiOutlinedInput-root": {
                        border: "1px solid rgba(186,186,186,0.3)",
                        borderRadius: "15px",
                      },
                    }}
                    inputRef={(el) => (otpFieldsRef.current[index] = el)}
                    error={!!otpError}
                  />
                ))}
                {otpError && (
                  <Box color={"#c62828"} pt={1}>
                    {otpError}
                  </Box>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isBtnDisabled}
                  sx={{
                    mt: 5,
                    height: "45px",
                    width: { xs: "80%", sm: "40%" }, // Make button width responsive
                    p: 2,
                    fontSize: { xs: "12px", sm: "14px" }, // Adjust font size for smaller screens
                    borderRadius: "10px",
                    textTransform: "none",

                    fontWeight: 600,
                  }}
                >
                  {t("otp_verify")}
                </Button>
                <Grid className="time_remains">
                  {!isDisabled && (
                    <Box mt={2} color={"#000"} fontSize={16} fontWeight={500}>
                      <Typography component="span">
                        {t("remain_time")} :
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          color: seconds > 0 ? "#1976d2" : "#000",
                          fontWeight: "bold",
                        }}
                      >
                        {minutes < 10 ? `0${minutes}` : minutes}:
                        {seconds < 10 ? `0${seconds}` : seconds}
                      </Typography>
                    </Box>
                  )}
                  {isDisabled && (
                    <Button
                      className="timer_btn"

                      sx={{ fontWeight: 600, marginTop: "5px" }}
                      onClick={resendOtp}
                    >
                      {t("resend_otp")}
                    </Button>
                  )}
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Checkbox
                      size="small"
                      checked={isChecked} // Controlled by state
                      onChange={handleCheckboxChange} // Handle state change
                    />
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "14.5px", letterSpacing: 0.3 }}
                    >
                      Don't want to receive OTP next time.
                    </Typography>
                  </Box>
                </Grid>
              </form>
            </Box>
          </Box>
        </Modal>
        <Dialog
          open={confirmDialogOpen}
          onClose={handleConfirmNo}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{ textAlign: "center", fontWeight: 600, color: "#d32f2f" }}
          >
            Multiple Sessions Are Not Allowed
          </DialogTitle>

          <DialogContent>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "17px",
                lineHeight: "24px",
                color: "gray",
                px: 2,
              }}
            >
              Multiple users cannot use the same account at the same time.
              Another session is currently active. Do you want to continue? If
              you proceed, the other user will be logged out.
            </Typography>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
            <Button
              sx={{
                height: "45px",
                fontSize: "16px",
                borderRadius: "10px",
                textTransform: "none",
              }}
              onClick={handleConfirmYes}
              variant="contained"
              color="primary"
            >
              Proceed
            </Button>

            <Button
              sx={{
                height: "45px",
                fontSize: "16px",
                borderRadius: "10px",
                textTransform: "none",
              }}
              onClick={handleConfirmNo}
              variant="contained"
              color="primary"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
};
export default Login;
